interface ChosenPanelProps extends React.PropsWithChildren {
  is: number
}

const ChosenPanel = ({ is = 0, children }: ChosenPanelProps) => {
  return children![is]
}

export default ChosenPanel
